import { render } from "./exam.vue?vue&type=template&id=6f9b2e4c&scoped=true"
import script from "./exam.vue?vue&type=script&lang=js"
export * from "./exam.vue?vue&type=script&lang=js"

import "./exam.vue?vue&type=style&index=0&id=6f9b2e4c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f9b2e4c"]])

export default __exports__